import React, { Component } from "react";
import { Grid, Button, Dropdown, Label, Message } from "semantic-ui-react";
import moment from "moment";
import "../accounting.css";
// import TMTable from "./tmtable";
// import Notification from "../../shared-components/Notification";
class CreateTNM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wedates: [props.lastWeDate],
      tnms: props.tnms,
      tmstatus: true,
      message: null
    };
  }

  createtnm(date) {
    this.props.gentnm(date).then(tmstuffs => {
      this.setState({ tnms: this.props.tnms });
    });
  }

  renderbutton() {
    if (
      this.state.wedates.length > 0 &&
      !this.props.tnms &&
      !this.state.tmstatus
    ) {
      return (
        <Button
          id="creattnmbutton"
          color="blue"
          onClick={() => {
            this.props.handlecreate(this.state.wedates);
          }}
        >
          Build T&M's
        </Button>
      );
    } else if (
      this.props.tnms &&
      this.state.tmstatus &&
      this.state.wedates.length > 0
    ) {
      return (
        <Button
          id="creattnmbutton"
          color="green"
          onClick={() => {
            this.props.handlepost(this.props.tnms);
          }}
        >
          Approve/Submit T&M's
        </Button>
      );
    }
  }
  genmessage() {
    if (this.state.message && this.state.message.length) {
      if (this.state.message === "TMSuccess") {
        return (
          <Message info>
            <Message.Header>Time and Materials created</Message.Header>
            <p>T&Ms have been created successfully</p>
          </Message>
        );
      } else {
        return (
          <Message negative>
            <Message.Header>Error Creating T&Ms</Message.Header>
            <p>this.state.message</p>
          </Message>
        );
      }
    }
  }
  render() {
    const tableoptions = ["TM Number"];
    const today = moment().format("DD/MM/YYYY");

    return (
      <div className="CreateTNM">
        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>
              <Label>Select dates to run T&M</Label>
              <Dropdown
                name="workorderCompDept"
                fluid
                multiple
                selection
                onChange={(e, { value }) => {
                  this.setState({ wedates: value });
                  this.props.handlecreate(value);
                }}
                options={this.props.weeksAvailable}
                value={this.state.wedates}
              />
            </Grid.Column>

            <Grid.Column width={2}>{this.renderbutton()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={10}>{this.props.children}</Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default CreateTNM;



// WEBPACK FOOTER //
// ./src/components/accounting/tnm/createtnm.jsx